
import Layout from '@/layout'

const userManualRouter = {
  path: '/instruct',
  component: Layout,
  name: 'userManual',
  meta: {
    title: 'operation',
    icon: 'frame31'

  },
  children: [
    {
      path: 'userManual',
      component: () => import('@/views/instruct/userManual'),  
      name: 'UserManual',
      meta: { title: 'userManual', icon: 'frame21', code: 'tech:briefing' }
    },
    {
      path: 'maintenance',
      component: () => import('@/views/instruct/maintenance'),
      name: 'Maintenance',
      meta: { title: 'maintenance', icon: 'frame33', code: 'tech:activity' }
    },
    {
      path: 'dismantling',
      component: () => import('@/views/instruct/dismantling'),
      name: 'Dismantling',
      meta: { title: 'disassembly', icon: 'dismant', code: 'tech:disassemble' }
    },
    {
      path: 'version',
      component: () => import('@/views/instruct/version'),
      name: 'Version',
      meta: { title: 'version', icon: 'diagnostic', code: 'tech:software' }
    }
    // {
    //     path: 'emergency',
    //     component: () => import('@/views/instruct/emergency'),
    //     name: 'Emergency',
    //     meta: { title: 'emergency', icon: 'frame33' }
    //   }
  ]
}

export default userManualRouter
